import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { IdentifyUserType, TrackEventType } from "@src/resources/analytics/analytics.service";

const c = initContract();

const index = c.router({
  identifyUser: {
    method: "GET",
    path: "/analytics/identify-user",
    responses: {
      200: c.type<IdentifyUserType>(),
    },
  },
  trackEvent: {
    body: z.object({
      event: z.string(),
      properties: z.record(z.unknown()),
    }),
    method: "POST",
    path: "/analytics/track-event",
    responses: {
      200: c.type<TrackEventType>(),
    },
  },
});

export default index;
